import { render, staticRenderFns } from "./preReceipt.vue?vue&type=template&id=b1dea672&"
import script from "./preReceipt.vue?vue&type=script&lang=js&"
export * from "./preReceipt.vue?vue&type=script&lang=js&"
import style0 from "./preReceipt.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports